import {Component} from "react";
import {DEBUG_MODE_FAST_TEXT} from "./constants";

export class RollingText extends Component {
  state = {
    timerId: -1,
    count: 0,
    ended: false,
  }

  componentWillUnmount() {
    clearTimeout(this.state.timerId)
    clearInterval(this.state.timerId)
  }

  runTheTimer = () => {
    this.setState({count: this.state.count + 1})

    if (this.state.count >= this.props.text.length) {
      this.props.onEnd();
    }
  }

  componentDidMount() {
    const timerId = setInterval(this.runTheTimer, DEBUG_MODE_FAST_TEXT ? 10 : 150)

    this.setState({timerId})
  }

  render() {
    return this.props.text.substr(0, this.state.count)
  }
}